import { computed, unref, type MaybeRef } from "vue";
import { createQuery } from "@/queries";
import { autocomplete } from "@/features/search/api/search";
import type { SearchAutocomplete } from "@/types/searchItemsTypes";

export interface AutocompleteQueryInput {
  search_text: string;
  size?: number;
  suggestions_size?: number;
  suggested_brands_size?: number;
}

export const useAutocompleteQuery = (
  input: MaybeRef<AutocompleteQueryInput | null | undefined>,
  enabled?: MaybeRef<boolean | undefined>,
) => {
  return createQuery<SearchAutocomplete>({
    key: computed(() => {
      const value = unref(input);
      const text = value?.search_text?.trim();
      if (!text) return null;
      return [
        "search",
        "autocomplete",
        text,
        value?.size ?? null,
        value?.suggestions_size ?? null,
        value?.suggested_brands_size ?? null,
      ];
    }),
    fetcher: async () => {
      const value = unref(input);
      const text = value?.search_text?.trim();
      if (!text) {
        throw new Error("search text is required");
      }
      const response = await autocomplete({
        search_text: text,
        size: value?.size,
        suggestions_size: value?.suggestions_size,
        suggested_brands_size: value?.suggested_brands_size,
      });
      return response.data;
    },
    enabled: computed(() => {
      const baseEnabled = enabled === undefined ? true : Boolean(unref(enabled));
      const text = unref(input)?.search_text?.trim();
      return baseEnabled && Boolean(text);
    }),
    staleTime: 30 * 1000,
  });
};

